import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=37a3c4ee&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=37a3c4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3c4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a3c4ee')) {
      api.createRecord('37a3c4ee', component.options)
    } else {
      api.reload('37a3c4ee', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=37a3c4ee&scoped=true&", function () {
      api.rerender('37a3c4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26pe8GTqxa6Ls/JS/comp/DateRange.vue"
export default component.exports